import React, { useLayoutEffect, useState } from "react";
import { Button, Col, Row, Tabs } from "antd";
import LS_SERVICE from "../../../../utils/localStorage";
import { postAPI } from "../../../../utils/common";
import { BACKEND_BASE_URL, USER_DETAIL } from "../../../../constants/api";
import "./LoginUi.css"; // Keep CSS imports at the end of imports
import LoginModal from "./LoginModal";
import { RADIUS } from "../../../../constants/constent";

// 👇 Move this here
const { TabPane } = Tabs;

const HeaderComponent = ({
  logoSrc,
  company_name,
  isLoggedIn,
  setIsLoggedIn,
  activeTab,
  setActiveTab,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLoginClick = () => {
    setIsModalVisible(true);
  };

  const handleLogout = () => {
    setLoading(true);
    LS_SERVICE.login_clear();
    window.location.reload();
    setIsLoggedIn(false);
    setLoading(false);
  };

  // Fetch user data from API
  const getUserData = async () => {
    const data = new FormData();
    data.append("id", LS_SERVICE.get("id"));

    const successFn = (data) => {
      if (data.status === true) {
        LS_SERVICE.set("name", data.user.name);
        LS_SERVICE.set("user_type", data.user.user_type);
        LS_SERVICE.set("phone", data.user.phone);
        LS_SERVICE.set("email", data.user.email);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    const errorFn = () => {
      setIsLoggedIn(false);
    };

    await postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  // Fetch data on component mount
  useLayoutEffect(() => {
    const loadData = async () => {
      setLoading(true);
      if (LS_SERVICE.get("id") && LS_SERVICE.get("user_type") === "customer") {
        await getUserData();
      }
      setLoading(false);
    };

    loadData();
  }, []);

  const handleLinkClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <header className="header">
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col xs={!isLoggedIn ? 12 : 24} sm={12}>
          <a
            style={{ float: "left" }}
            onClick={() => handleLinkClick(BACKEND_BASE_URL)}
          >
            <img className="logo" src={logoSrc} alt={company_name} />
          </a>
        </Col>
        <Col xs={!isLoggedIn ? 12 : 24} sm={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexWrap: "wrap",
              gap: "1rem",
              align: "middle",
            }}
          >
            {!isLoggedIn ? (
              <Button
                style={{ borderRadius: RADIUS }}
                loading={loading}
                onClick={handleLoginClick}
              >
                Login / Signup
              </Button>
            ) : (
              <>
                <Tabs
                  activeKey={activeTab}
                  onChange={(key) => setActiveTab(key)}
                >
                  <TabPane tab="Home" key="1" />
                  {isLoggedIn && <TabPane tab="My Booking" key="2" />}
                  {isLoggedIn && <TabPane tab="Profile" key="3" />}
                </Tabs>

                <Button
                  style={{
                    marginTop: "10px",
                    borderRadius: RADIUS,
                  }}
                  danger
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* Login Modal */}
      <LoginModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setIsLoggedIn={setIsLoggedIn}
      />
    </header>
  );
};

export default HeaderComponent;
